<template>
  <form class="vx-row items-center justify-between">
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-6 md:mb-0">
      <small class="mb-2"><strong>Nomor Telpon</strong></small>
      <vs-input type="number" class="w-full" v-model="myNumber" />
    </div>
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3">
      <small class="mb-2"><strong>Paket Data</strong></small>
      <v-select 
        v-model="product"
        class="w-full" 
        :options="products"
      />
    </div>
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3">
      <small class="mb-2 text-white">d</small>
      <vs-button @click.prevent="payTopup" id="btn-topup" class="w-full rounded" color="primary">Beli</vs-button>
    </div>
  </form>
</template>
<script>
import vSelect from 'vue-select'
import { numDetect } from '@/assets/utils/ppob'

export default {
  components: {
    vSelect
  },
  data: () => ({
    myNumber: null,
    product: null,
    products: [],
    operator: null
  }),
  methods: {
    payTopup() {

      if(this.myNumber === null || this.product === null) {
        this.$vs.notify({
          title: 'Harap lengkapi nomor dan nominal',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      if(this.myNumber.toString().length < 10 ||
        this.myNumber.toString().length > 13) {
        this.$vs.notify({
          title: 'Harap masukan nomer yang valid',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      this.$vs.loading({
        container: '#btn-topup',
        scale: 0.5
      })

      this.product.user_number = this.myNumber.toString()

      // Set selected product dan myNumber
      this.$store.dispatch('data/setTransactionProduct', this.product)
      .then(() => {
        this.$vs.loading.close('#btn-topup > .con-vs-loading')
        this.$router.push(`/top-up-tagihan/data/checkout/choose-payment`)
      })
    },
    setCatProduct(category, i) {
      // toggle active class
          document.getElementsByClassName('topup-product').forEach(item => {
          item.setAttribute('class', 'topup-product px-4')
        })
      document.getElementById(`topup-product-${i}`).setAttribute('class', 'topup-product px-4 selected-topup')
      this.categoryPpob = category
      this.products = []
      this.product = null

      if(this.myNumber !== null) {
        const operator = this.getOperator(this.myNumber.toString())

        if (operator) {
          this.operator = operator

          // get nominal by operator
          this.getProduct(operator.key)
        }
      }
    },
    getProduct (paket) {
        this.$store.dispatch('ppob/getPrabayar', {
          type: 'data',
          paket
        })
        .then(payload => {
          payload.products.forEach(item => {
            item.active = false
            item.label = item.pulsa_nominal
          })
          this.products = payload.products
          this.products[0].active = true
        })
        .catch(e => {
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

            return false
        })
    }
  }
}
</script>